import React from 'react';
import AntBreadcrumb, { BreadcrumbProps } from 'antd/lib/breadcrumb';
import { ItemType } from 'antd/lib/breadcrumb/Breadcrumb';
import { Link } from 'react-router-dom';
import styles from './Breadcrumb.module.scss';
import { Tooltip } from 'antd';

function itemRender<T>(route: ItemType, _params: T, routes: ItemType[]) {
  const last = routes.indexOf(route) === routes.length - 1;
  const tooLongText = route?.title && route?.title.toString().length > 30;

  const tooltipTitle = tooLongText ? (
    <span className="text-1424 text-black">{route.title}</span>
  ) : undefined;

  const displayTitle = tooLongText ? `${route.title?.toString().slice(0, 30)}...` : route.title;

  const content =
    last || !route.path ? (
      <span className="max-w-[10rem] truncate">{displayTitle}</span>
    ) : (
      <Link to={route.path}>{displayTitle}</Link>
    );

  return (
    <Tooltip
      color="white"
      title={tooltipTitle}
    >
      {content}
    </Tooltip>
  );
}

export const Breadcrumb = (props: BreadcrumbProps) => (
  <AntBreadcrumb
    itemRender={itemRender}
    {...props}
    className={styles.breadcrumb}
  />
);
